
import { application } from './application';
import { auth } from './auth';
import { categories } from './categories';
import { common } from './common';
import { dashboard } from './dashboard';
import { euportal } from './euportal';
import { extension } from './extension';
import { farm } from './farm';
import { features } from './features';
import { footer } from './footer';
import { forms } from './forms';
import { home } from './home';
import { messages } from './messages';
import { navigation} from './navigation';
import { search } from './search';
import { simulation } from './simulation';
import { status } from './status';
import { subsidies } from './subsidies';
import { subsidyTracking } from './subsidyTracking';
import { calendar } from './calendar';
import { admin } from './admin';
import { legal } from './legal';
import { processing } from './processing';
import { profile } from './profile';
import { settings } from './settings';
import { companySearch } from './companySearch';
import { passwordReset } from './passwordReset';
import { productDetails } from './productDetails';
import { discover } from './discover';
import { expertRegistration } from './expertRegistration';
import { pricing } from './pricing';
import { help } from './help';
import { onboarding } from './onboarding';
import { mfa } from './mfa';
import { trial } from './trial';
import { functionalitiesPage } from './functionalitiesPage';
import { companyPage } from './companyPage';

export const fr = {
  ...application,
  ...auth,
  ...categories,
  ...common,
  ...dashboard,
  ...euportal,
  ...extension,
  ...farm,
  ...features,
  ...footer,
  ...forms,
  ...home,
  ...messages,
  ...navigation,
  ...search,
  ...simulation,
  ...status,
  ...subsidies,
  ...subsidyTracking,
  ...calendar,
  ...admin,
  ...legal,
  ...processing,
  ...profile,
  ...settings,
  ...companySearch,
  ...passwordReset,
  ...productDetails,
  ...discover,
  ...expertRegistration,
  ...pricing,
  ...help,
  ...onboarding,
  ...mfa,
  ...trial,
  ...functionalitiesPage,
  ...companyPage,
} as const;
